import { sanitizeInput } from './inputValidation';

const UNSAFE_PATTERNS = [
  'Cannot read',
  'TypeError',
  'ReferenceError',
  'SyntaxError',
  'undefined is not',
  'null is not',
  'is not a function',
  'chunk',
  'webpack',
  'at Object',
  'at Module',
  'at Function',
];

export const getSafeErrorMessage = (
  error: unknown,
  fallback = 'Something went wrong. Please try again.'
): string => {
  if (!error) return fallback;

  const msg = error instanceof Error ? error.message : String(error);

  if (msg.length > 150) return fallback;

  if (UNSAFE_PATTERNS.some((pattern) => msg.includes(pattern))) {
    return fallback;
  }

  return sanitizeInput(msg) || fallback;
};
